import React, { useState } from "react";
import { Form, Input, Button, Alert } from "antd";
import RangerLayout from "layouts/RangerLayout/RangerLayout";
import StyledButton from "components/button/Button";

const Login = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    setError("");
    // TODO: Replace with real authentication logic
    setTimeout(() => {
      setLoading(false);
      if (values.username === "ranger" && values.password === "password") {
        window.location.href = "/";
      } else {
        setError("Invalid username or password");
      }
    }, 1000);
  };

  return (
    <RangerLayout title="Ranger Login">
      <div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input placeholder="Enter username" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Enter password" />
          </Form.Item>
          {error && (
            <Form.Item>
              <Alert message={error} type="error" showIcon closable onClose={() => setError("")} />
            </Form.Item>
          )}
          <Form.Item>
            <StyledButton
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              Login
            </StyledButton>
          </Form.Item>
        </Form>
      </div>
    </RangerLayout>
  );
};

export default Login;
